import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import withStyles from '@mui/styles/withStyles';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import AccountCircle from '@mui/icons-material/AccountCircle';
import Menu from '@mui/material/Menu';
import CssBaseline from '@mui/material/CssBaseline';
import MenuIcon from '@mui/icons-material/Menu';
import ExitToApp from '@mui/icons-material/ExitToApp';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import {ThemeProvider, StyledEngineProvider} from '@mui/material/styles';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ContactMailIcon from '@mui/icons-material/ContactMailOutlined';
import HelpIcon from '@mui/icons-material/Help';

import {authOperations} from './../../../reducks/auth';
import {commonOperations} from './../../../reducks/common';
import Hidden from '@mui/material/Hidden';
import Drawer from '@mui/material/Drawer';

import CommonTheme from '../../../Theme.js';
import withRouter from '../withRouter.js';
import {withMediaQuery} from '../../atoms/withMediaQuery.js';

import conf from '../../../config/config.js';
import SideMenu from '../SideMenu/SideMenu.js';
import {CORP_CD, GMN, GMN_PATH} from '../../../common/commonConst.js';
import {setSessionObject} from '../../../common/Session.js';

const drawerWidth = 280;

const styles = (theme) => ({
  root: {
    display: 'flex',
  },
  topgrow: {
    flexGrow: 1,
    margin: '3px 3px 3px 3px',
  },
  grow: {
    flexGrow: 1,
    textAlign: 'left',
    padding: '0px 3px 10px 3px',
  },
  UserHeader: {
    textAlign: 'center',
    margin: '86px 24px 20px 24px',
  },
  appBarTop: {
    top: 0,
  },
  appBar: {
    top: 22,
  },
  appBarCommon: {
    maxWidth: CommonTheme.breakpoints.values.lg,
    marginLeft: 'auto',
    marginRight: 'auto',
    left: 0,
    right: 0,
    // zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),

    [theme.breakpoints.up(CommonTheme.breakpoints.values.lg)]: {
      maxWidth: 'calc(' + CommonTheme.breakpoints.values.lg + 'px + ' + CommonTheme.menu.width + 'px)',
      width: '100%',
    },
  },
  toolHeight: {
    minHeight: 40,
  },
  sideColor: {
    background: 'rgb(79,134,197)',
    color: '#fff',
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
    display: 'none',

    [theme.breakpoints.down(
        CommonTheme.breakpoints.values.lg + CommonTheme.menu.width,
    )]: {
      display: 'inline',
    },
  },
  menuButtonHidden: {
    display: 'none',
  },
  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9),
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  userInfo: {
    margin: '0 0 0 auto',
    textAlign: 'center',
  },
  daikoUser: {
    color: '#F28156',
  },
  titleSystem: {
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: '10px',
    lineheight: '100px',
    fontWeight: 'bold',
  },
});

class Header extends React.Component {
  state = {
    anchorEl: null,
    tabValue: 0,
    tab: 'home',
    openSide: false,
    current: new Date(),
    showDialog: false,
  };
  static propTypes = {
    match: PropTypes.object.isRequired,
    location: PropTypes.object,
  };

  componentDidMount = () => {
  };

  componentWillUnmount = () => {
  };

  handleMenu = (event) => {
    this.setState({anchorEl: event.currentTarget});
  };

  handleClose = () => {
    this.setState({anchorEl: null});
  };

  handleDrawerOpen = (event) => {
    this.setState({openSide: true});
  };

  handleDrawerClose = () => {
    this.setState({openSide: false});
  };

  doChangePassword = () => {
    this.handleClose();
    this.props.navigate('/changePassword');
  };

  doUserUpdate = (userInfo) => {
    this.handleClose();

    let params = {
      userId: userInfo.userId,
      company: userInfo.corpCd,
      prefCode: '',
      transitionList: [
        {gmnName: GMN.MENU.name, href: GMN_PATH.MENU},
      ],
    };
    // ユーザ詳細画面に遷移
    setSessionObject(GMN.USER_MASTER_INFO.id, params);
    this.props.navigate(GMN_PATH.USER_MASTER_INFO);
  };

  doHelp = () => {
    this.handleClose();
    window.open(conf.MANUAL_PDF_URL, '_blank');
  };

  doLogout = () => {
    const {
      dirty,
      doLogout,
      doShowMessage,
      isEditPage,
    } = this.props;

    // 編集画面で値が変更されているかどうかでメッセージを差し換え
    const messageId = (isEditPage && dirty) ? 'TKSCZ00060W' : 'TKSCS00002C';

    doShowMessage({
      message: {
        id: messageId,
        values: ['ログアウト'],
      },
      action: () => {
        this.handleClose();
        doLogout();
      },
    });
  };

  /**
   * ログインユーザ名の取得
   * @param {object} userInfo ユーザ情報
   * @return {string} ログインユーザ名
   */
  getUserName = (userInfo) => {
    let nameItems;
    const officeName = userInfo.corpCd === CORP_CD.CBID_USER ?
      userInfo.nwOfficeName : userInfo.surveyAgencyOfficeName;

    nameItems = [userInfo.userName, '　('+ userInfo.userId + ')　', officeName];
    return nameItems.join('');
  };

  render() {
    const {
      classes,
      disableSideMenu,
      userInfo,
      isLoggedIn,
    } = this.props;

    const anchorEl = this.state.anchorEl;
    const openIcon = Boolean(anchorEl);
    const title = this.props.title;
    const openSide = this.state.openSide;
    const imgUrl = '../images/logo.png';

    // ログインユーザ名
    let userName = '';

    // ユーザ情報が設定さた場合、各種情報を取得
    if (userInfo) {
      userName = this.getUserName(userInfo);
    }

    return (
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={CommonTheme}>
          <div className={classes.root}>
            <CssBaseline />
            <AppBar position="absolute" className={clsx(classes.appBarTop, classes.appBarCommon)} style={{color: 'black', backgroundColor: 'palegreen'}}>
              <Typography variant="caption" color="inherit" className={classes.topgrow} >
                <span className={classes.titleSystem}>
                  <img src={imgUrl} alt="logo" style={{width: 120, height: 15}}/>
                  <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;定期調査システム</span>
                </span>
              </Typography>
            </AppBar>
            <AppBar position="absolute" className={clsx(classes.appBar, openSide && classes.appBarShift, classes.appBarCommon)} style={{height: '40px'}}>
              <Toolbar className={classes.toolbar}>

                <>
                  {!disableSideMenu &&
                    <IconButton
                      edge="start"
                      color="inherit"
                      aria-label="open drawer"
                      onClick={this.handleDrawerOpen}
                      className={clsx(
                          classes.menuButton,
                          openSide && classes.menuButtonHidden)}
                      sx={{padding: '0px 3px 10px 3px'}}
                    >
                      <MenuIcon />
                    </IconButton>
                  }
                </>

                <Typography variant="h6" color="inherit" className={classes.grow} >
                  {title}
                </Typography>

                {isLoggedIn &&
                  <Hidden xsDown>
                    <Typography
                      color="inherit"
                      className={clsx(classes.userInfo)}
                      sx={{padding: '0px 3px 10px 3px'}}
                    >
                      {userName}
                    </Typography>
                  </Hidden>
                }

                {isLoggedIn &&
                  <div>
                    <IconButton
                      aria-owns={openIcon ? 'menu-appbar' : undefined}
                      aria-haspopup="true"
                      onClick={this.handleMenu}
                      color="inherit"
                      sx={{padding: '0px 3px 15px 3px'}}
                    >
                      <AccountCircle />
                    </IconButton>
                    <Menu
                      id="menu-appbar"
                      anchorEl={anchorEl}
                      anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                      }}
                      transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                      }}
                      open={openIcon}
                      onClose={this.handleClose}
                    >
                      <ListItemButton onClick={this.doChangePassword}>
                        <ListItemIcon>
                          <ContactMailIcon />
                        </ListItemIcon>
                        <ListItemText primary="パスワード変更" />
                      </ListItemButton>
                      <ListItemButton onClick={
                        () => this.doUserUpdate(userInfo)}>
                        <ListItemIcon>
                          <AccountCircle />
                        </ListItemIcon>
                        <ListItemText primary="ユーザ詳細" />
                      </ListItemButton>
                      <ListItemButton onClick={this.doHelp}>
                        <ListItemIcon>
                          <HelpIcon />
                        </ListItemIcon>
                        <ListItemText primary="ヘルプ" />
                      </ListItemButton>
                      <ListItemButton onClick={this.doLogout}>
                        <ListItemIcon>
                          <ExitToApp />
                        </ListItemIcon>
                        <ListItemText primary="ログアウト" />
                      </ListItemButton>
                    </Menu>
                  </div>
                }
              </Toolbar>
            </AppBar>
            <Drawer
              variant="temporary"
              classes={{
                paper: clsx(
                    classes.drawerPaper,
                    !openSide && classes.drawerPaperClose,
                    classes.sideColor,
                ),
              }}
              open={openSide}
            >
              <div className={clsx(classes.toolbarIcon, classes.sideColor)}>
                <IconButton onClick={this.handleDrawerClose}>
                  <ChevronLeftIcon style={{color: 'white'}} />
                </IconButton>
              </div>
              <SideMenu {...this.props} />
            </Drawer>
          </div>
        </ThemeProvider>
      </StyledEngineProvider>
    );
  }
}

Header.propTypes = {
  classes: PropTypes.object.isRequired,
  dirty: PropTypes.bool,
  doLogout: PropTypes.func.isRequired,
  doShowMessage: PropTypes.func.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
  disableSideMenu: PropTypes.bool,
  title: PropTypes.string,
  userInfo: PropTypes.object,
  openSideWindow: PropTypes.bool,
  isEditPage: PropTypes.bool,
  navigate: PropTypes.func,
};

const mapStateToProps = (state) => ({
  currentTheme: state.style.theme,
  isLoggedIn: state.auth.isLoggedIn,
});

const mapDispatchToProps = {
  doLogout: authOperations.doLogoutOperation,
  doShowMessage: commonOperations.doShowMessage,
};

export default withStyles(styles)(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    )(withRouter(withMediaQuery()(Header))),
);
